// @flow

import { type UserInputValues } from './types';
import { type UserInputName } from '@tectonics/prs/user-input';

type ReturnType = {|
  values: UserInputValues,
  setValue: (UserInputName, any) => void,
|};

export function fakeUserInputValues(initialState?: $Shape<UserInputValues>): ReturnType {
  let values = initialState || {};

  function setValue(name: UserInputName, value: any) {
    Object.assign(values, { [name]: value });
  }

  setValue('selectedInstalment', values.selectedInstalment || '1');

  return { values, setValue };
}
